<template>
  <v-dialog max-width="500px" v-bind="$attrs" v-model="show">
    <file-picker
      :accept="accept || '.pdf'"
      :title="title"
      multiple
      slot="activator"
      v-bind="$attrs"
      v-model="files"
    ></file-picker>
    <v-card>
      <v-card-title>アップロード</v-card-title>
      <v-list two-line>
        <v-list-tile :key="index" v-for="(f, index) in files">
          <v-list-tile-content>
            <v-list-tile-title>{{ f.name }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <v-progress-linear
                class="mt-0"
                v-model="f.progress"
              ></v-progress-linear>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" flat v-if="!uploading">クローズ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Promise } from "q";
export default {
  props: [
    "title",
    "domain",
    "businessKey",
    "category",
    "accept",
    "allowDuplicateName",
    "type",
    "id",
    "newFileName",
  ],
  data() {
    return {
      show: false,
      uploading: false,
      files: [],
      errors: {
        UPLOAD_FAILED:
          "PDFファイルアップロード失敗しました。もう一度お試してお願いいたします。",
      },
    };
  },
  watch: {
    files() {
      if (this.files.length <= 0) return;
      // this.show = true;
      // this.uploading = true;

      this.directUpload();
      // Promise.all(this.getRemoveTasks())
      //   .then((results) => {
      //     console.log({ results })
      //     return Promise.all(this.getUploadTasks())
      //   })
      //   .then((results) => {
      //     console.log({ results })
      //     this.uploading = false
      //   })
    },
  },
  methods: {
    directUpload() {
      const ex = this.$getFileEx();
      console.log(ex);
      const bucketName = localStorage.getItem(bucketName);
      this.files.forEach((f) => {
        var newNameFile;
        if (this.newFileName) {
          newNameFile = new File([f.file], this.newFileName, {
            type: f.type,
          });
          ex.initFileUploadFn(newNameFile, bucketName, this.newFileName)
            .then((res) => {
              this.$emit("addAttachment", {
                fileOssId: res.data.fileId,
                businessType: this.type,
                name: this.newFileName,
              });
            })
            .catch((err) => {
              console.log(err);
              if ("TimeOut" === err) {
                this.$message(
                  "",
                  "タイムアウトになったため、アップロード失敗しました。もう一度試してください。"
                );
                return;
              }
              this.$showError(
                err,
                "ネットワーク不安定のため、後でもう一度試してください。"
              );
            });
        } else {
          ex.initFileUploadFn(f.file, bucketName, f.name)
            .then((res) => {
              this.$emit("addAttachment", {
                fileOssId: res.data.fileId,
                businessType: this.type,
                name: f.name,
              });
            })
            .catch((err) => {
              console.log(err);
              if ("TimeOut" === err) {
                this.$message(
                  "",
                  "タイムアウトになったため、アップロード失敗しました。もう一度試してください。"
                );
                return;
              }
              this.$showError(
                err,
                "ネットワーク不安定のため、後でもう一度試してください。"
              );
            });
        }
      });
    },
    getRemoveTasks() {
      if (this.allowDuplicateName) return ["skip Remove Duplicate Task"];
      return this.$http.get(`/files/${this.domain}/files`).then((res) => {
        let oldFiles = res.data;
        let removeTasks = this.files.map((f) => {
          let old = oldFiles.find(
            (o) => f.name === o.name && o.category === this.category
          );
          if (old) {
            return this.$http
              .delete(`/files/${this.domain}/files/${old.id}`)
              .then(() => `remove file ${old.name} id:${old.id}`);
          } else {
            return `${f.name} not duplicate`;
          }
        });
        return removeTasks;
      });
    },
    getUploadTasks() {
      return this.files.map((f) => {
        var newNameFile;
        console.log("files map:", f);
        if (this.newFileName) {
          newNameFile = new File([f.file], this.newFileName, {
            type: f.type,
          });
        }
        console.log("newNameFile", newNameFile);
        let formData = new FormData();
        formData.append("file", newNameFile || f.file);
        this.$http
          .post(`/tdoc/files/${this.type}/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              sortable: false,
            },
          })
          .then((res) => {
            this.$emit("addAttachment", res.data);
          })
          .catch((err) => {
            console.log(err.response);
            if ("TimeOut" === err) {
              this.$message(
                "",
                "タイムアウトになったため、アップロード失敗しました。もう一度試してください。"
              );
              return;
            }
            this.$showError(
              err,
              "ネットワーク不安定のため、後でもう一度試してください。"
            );
          });
      });
    },
  },
};
</script>
